






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { BACKEND_URL } from '@/helpers/constants';
import AuthModule from '@/store/AuthModule';

@Component
export default class ExportProgressPopup extends Vue {
  @Prop({ default: false }) active!: boolean;
  @Prop({ required: true }) userId!: number;

  progress = {
    processed: 0,
    total: 0,
    progressPercentage: 0,
    currentFile: '',
    humanRemainingSize: '',
    documentsRemaining: 0,
  };
  finished = false;
  interval: number | null = null;

  @Watch('active', { immediate: true })
  async onActiveChange(val: boolean) {
  if (val) {

      // 2) Réinitialiser l’état
      this.finished = false;
      this.progress = {
      processed: 0,
      total: 0,
      progressPercentage: 0,
      currentFile: '',
      humanRemainingSize: '',
      documentsRemaining: 0,
      };

      // 3) Démarrer le polling
      this.startPolling();
  } else {
      if (this.interval) clearInterval(this.interval);
  }
  }


  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  }


  private startPolling() {
    if (this.interval) clearInterval(this.interval);
    const url = `${BACKEND_URL}/api/prescriber/lots/export-progress/${this.userId}`;
    this.interval = window.setInterval(async () => {
      try {
        const token = AuthModule.token;
        const { data } = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        this.progress = {
          processed: data.processed || 0,
          total: data.total || 0,
          progressPercentage: data.progressPercentage || 0,
          currentFile: data.currentFile || '',
          humanRemainingSize: data.humanRemainingSize || '',
          documentsRemaining: data.documentsRemaining || 0,
        };

        if (data.total > 0 && (data.progressPercentage >= 100 || data.documentsRemaining <= 0)) {
      clearInterval(this.interval!);
      this.finished = true;
      // no emit – wait for user to click outside to close
      }


      } catch (error) {
        console.error('Polling error:', error);
      }
    }, 500);
  }
}
